import { TResellerBranding } from '@/reseller/reseller.types';
import { getReseller } from '@/shared/utils/reseller/reseller';

const DEFAULT_RESELLER = 'sda';

// Branding lives at the env/build level (VITE_APP_SUPER_TENANT), not on the
// theme — light/midnight themes are shared across resellers, so the theme
// cannot be trusted to carry the reseller identity.
const resellerBranding = import.meta.glob<{ BRANDING: TResellerBranding }>(
  '../../../reseller/*/branding/branding.constants.ts',
  { eager: true },
);

const findBranding = (reseller: string): TResellerBranding | undefined => {
  const entry = Object.entries(resellerBranding).find(([path]) =>
    path.includes(`/${reseller}/branding/branding.constants.ts`),
  );

  return entry?.[1].BRANDING;
};

export const getResellerBranding = (): TResellerBranding => {
  const reseller = getReseller() || DEFAULT_RESELLER;

  return findBranding(reseller) ?? findBranding(DEFAULT_RESELLER)!;
};
